import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';

import { useVideoPlatform } from '../hooks/useVideoPlatform';
import { useTrackEvent } from '../segment/segment';
import { EventTypeEnum } from '../segment/types';
import { parseIdentity } from '../video-sdk';
import { admissionTrackingHistory } from './admission/analytics/AdmissionTrackingHistory';
import { inSessionPatientInformationAtom, providerShortIdAtom } from './state';

export function useTrackSessionParticipantViewedEvent(participantIdentity: string | undefined) {
  const { userViewed } = useTrackEvent();
  const providerShortId = useAtomValue(providerShortIdAtom) ?? '';
  const inSessionPatientInformation = useAtomValue(inSessionPatientInformationAtom);
  const videoPlatform = useVideoPlatform();
  const hasLoggedRef = useRef(false);

  useEffect(
    function emitSessionParticipantViewed() {
      if (hasLoggedRef.current || !participantIdentity) return;
      hasLoggedRef.current = true;

      const patientShortId = inSessionPatientInformation?.patientShortId ?? '';
      const appointmentShortId = inSessionPatientInformation?.inSessionAppointmentShortId ?? '';
      const { id: visitorId, userType: entityType } = parseIdentity(participantIdentity);
      const txId = (visitorId && admissionTrackingHistory.getByVisitorId(visitorId)?.admissionTransactionId) ?? '';

      userViewed(EventTypeEnum.SESSION_PARTICIPANT_VIEWED, {
        patientShortId,
        providerShortId,
        appointmentShortId,
        source: videoPlatform ?? inSessionPatientInformation?.videoPlatform ?? '',
        txId,
        entityId: visitorId ?? '',
        entityType,
      });
    },
    [inSessionPatientInformation, participantIdentity, providerShortId, userViewed, videoPlatform],
  );
}
